import { ChessService } from 'api/chess/service';
import { useCallback } from 'react';


export const useChess = () => {
    const onGetAllChess = useCallback(async () => {
        try {
            const response = await ChessService.getInstance().findAll();
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    const onGetOneChess = useCallback(async (id: number) => {
        try {
            const response = await ChessService.getInstance().findOne(id);

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    return { onGetAllChess, onGetOneChess };
};
